<homey-lotteries-dialog-content
  singleDescription="Congratulations! Your application has been selected! We will contact you through email to help you deal with the next steps in the process towards affordable housing."
  multipleDescription="Congratulations! Your applications have been selected! We will contact you through email to help you deal with the next steps in the process towards affordable housing."
  singleTitle="You've been selected!"
  multipleTitle="You've been selected!"
  [notification]="data()"
  [closeButton]="closeButton()"
>
  <ng-template lotteryDialogListItem let-lottery>
    <homey-lottery-list-item [apartment]="lottery" [openInPopup]="true">
      <p>Selected</p>
    </homey-lottery-list-item>
  </ng-template>
</homey-lotteries-dialog-content>
